import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode } from './common-interfaces';

import { OperationAssignmentsService } from './operation-assignments.service';
import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { FootprintApiManager_OperationService } from './FootprintApiManager.operation.service';
import { FootprintEdi_OperationService } from './FootprintEdi.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
    private operationAssignmentsService: OperationAssignmentsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_OperationService);
    this.FootprintEdi = this.injector.get(FootprintEdi_OperationService);
  }

  public Utilities: Utilities_OperationService;
  public FootprintApiManager: FootprintApiManager_OperationService;
  public FootprintEdi: FootprintEdi_OperationService;
  public app: app_OperationService = this;


  isAssigned(operationName: string, mode: EAssignmentMode): Promise<boolean> {
    var referenceName = null;    
    return Promise.resolve(this.operationAssignmentsService.isAssigned(referenceName, operationName, mode));
  }
}
